module.exports = __webpack_public_path__ + "static/media/3.5-hour.f94cd38c.png";